export enum EEntity {
  CONTACT = 'contact',
  ACCOUNT = 'account',
  PHONE_CALL = 'phonecall',
  LEAD = 'lead',
  OPPORTUNITY = 'opportunity',
  CASE = 'incident',
  CAMPAIGN = 'campaign',
  QUOTE = 'quote',
  INVOICE = 'invoice',
  ORDER = 'salesorder',
  SYSTEM_USER = 'systemuser',
  MARKETING_LIST = 'list',
  LIST_MEMBER = 'listmember',
  INSTALLED_MACHINE = 'new_installedmachine',
  // note default
  CHAT_NOTE = 'solgari_chat',
}

export enum EAssign {
  CONTACT = 'contact',
  LEAD = 'lead',
}
